import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler";
import { debounce } from "../../../../../../common/snippet/Debouncing";
import { GetAllProviderTypeList } from "../../../../../../actions/client-portal/reports/GetAllProviderTypeList";
function ProvideTyperMultiSelectDropdown({
  title,
  updateFilter,
  provider_org_ids,
}) {
  const [providerType_org_id, setProviderType_org_ids] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [items, setItems] = useState([]);
  const [checkData, setCheckData] = useState(false);
  const dropdownRef = useRef(null);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const dispatch = useDispatch();

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSeachChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const inputchangeSearch = useCallback(debounce(handleSeachChange), []);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (item) => {
    setCheckData(true);
    const newId = parseInt(item.providerType_id, 10);

    const exists = providerType_org_id.includes(newId);

    if (exists) {
      setProviderType_org_ids(
        providerType_org_id.filter((entry) => entry !== newId)
      );
    } else {
      setProviderType_org_ids([...providerType_org_id, newId]);
    }
  };

  const clearSelection = () => {
    setCheckData(true);
    setProviderType_org_ids([]);
  };
  useEffect(() => {
    if (checkData) {
      updateFilter("provider_type_ids", providerType_org_id);
    }
  }, [providerType_org_id]);

  const GetClientIdData = useCallback(
    async (provider_org_ids) => {
      if (provider_org_ids.length) {
        dispatch(
          GetAllProviderTypeList({
            provider_org_ids: JSON.stringify(
              provider_org_ids.map((item) => item?.provider_org_id)
            ),
            search: searchTerm,
          })
        ).then((response) => {
          if (response?.success === true) {
            const arrayData = response?.data;
            setItems(
              arrayData?.map((item) => ({
                name: item.providerType?.provider_type_name,
                providerType_id: item.providerType?.provider_type_id,
              }))
            );
          } else if (response?.status === 401) {
            handleUnauthorizedAccess();
          } else {
            // setLoadData(true);
          }
        });
      }
      // eslint-disable-next-line
    },
    [dispatch, searchTerm]
  );

  useEffect(() => {
    GetClientIdData(provider_org_ids);
    if (provider_org_ids.length == 0) {
      setProviderType_org_ids([]);
    }
  }, [searchTerm, provider_org_ids.length]);

  return (
    <div className="relative inline-block text-left w-34" ref={dropdownRef}>
      {/* Dropdown button */}
      <button
        onClick={toggleDropdown}
        disabled={provider_org_ids.length > 0 ? false : true}
        type="button"
        className="flex items-center justify-between w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        <span>{title}</span>
        {providerType_org_id?.length > 0 && (
          <span className="inline-flex ml-1 items-center justify-center w-6 h-6 text-sm font-semibold text-blue-700 bg-blue-100 rounded-full">
            {providerType_org_id.length}
          </span>
        )}
        <svg
          className="w-5 h-5 ml-2 text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown panel */}
      {isOpen && (
        <div className="absolute left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-10">
          {/* Header row: 'X providerType_org_id' and Clear button */}
          <div className="flex items-center justify-between p-2 border-b border-gray-200">
            <span className="text-sm text-gray-500">
              {providerType_org_id.length} selected
            </span>
            <button
              type="button"
              className="text-sm text-blue-600 hover:underline focus:outline-none"
              onClick={clearSelection}
            >
              Clear
            </button>
          </div>

          {/* Search input */}
          <div className="p-2">
            <input
              type="text"
              placeholder="Type here"
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              // value={searchTerm}
              onChange={(e) => inputchangeSearch(e)}
            />
          </div>

          {/* Scrollable list of items */}
          <ul className="max-h-48 overflow-y-auto">
            {items?.map((item) => (
              <li
                key={item.organisation_id}
                className="flex items-center px-3 py-2 hover:bg-gray-50"
              >
                <input
                  type="checkbox"
                  className="w-4 h-4 mr-2 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  // checked={providerType_org_id?.provider_org_id?.includes(
                  //   parseInt(item.provider_org_id, 10)
                  // )}
                  checked={providerType_org_id?.includes(
                    parseInt(item.providerType_id, 10)
                  )}
                  onChange={() => handleSelect(item)}
                />
                <span className="text-sm text-gray-700">{item.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default ProvideTyperMultiSelectDropdown;
